import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ProductTypeGroup, ProductTypeProductTypeGroup } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeGroupService extends TmsWebBaseEditService<ProductTypeGroup, ProductTypeGroup> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductTypeGroup', $localize`Product Type Group`);
  }

  getForAllProductTypeGroup(id: string): Observable<ProductTypeProductTypeGroup[]> {
    return this.httpService.get<ProductTypeProductTypeGroup[]>(`${this.apiUrl}/GetAllForProductTypeGroup/${id}`);
  }

  updateProductTypeGroups(productTypeGroupId: string, productTypeIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateProductTypeGroups`, {
      productTypeGroupId,
      productTypeIds,
    });
  }
}
